import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { filter, map } from 'rxjs';
import { AuthFacade, AuthService } from '@lyceo/shared/auth/data-access';
import { toObservable } from '@angular/core/rxjs-interop';

export function forcedLoginGuard(): CanActivateFn {
  return () => {
    const authService: AuthService = inject(AuthService);
    const authFacade: AuthFacade = inject(AuthFacade);

    return toObservable(authFacade.isDoneLoading).pipe(
      filter((isDone) => isDone),
      filter(() => !authFacade.loginError()),
      map(() => {
        if (authFacade.isAuthenticated()) {
          return true;
        }

        authService.forcedLogin();

        return false;
      }),
    );
  };
}
